import BaseEvent from "./BaseEvent";
export default class WarpEvent extends BaseEvent {
    constructor(beat, time, index) {
        super();
        this.PRIORITY = 2;
        this.BEAT = beat;
        this.INDEX = index;
        this.TIME = time;
    }
}
